import axiosV2 from '@/utils/request'
import service from '@/utils/axios-v2'
import axios from 'axios'
import { systemInfo } from '@/shared-services';

/**
 * 
 * @load 获取load列表
 * @loadDetail 查询load详情
 * @loadAdd 添加load接口
 * @loadDel 删除当前load
 * @calculateRoute 计算路线长度及邮费
 * 
 */

export function driverHos(driverId) {
  return service({
    url: `/fleet/driver/get/hos/info?id=${driverId}`,
    method: 'get',
    headers: {
      'portal-token': true,
    },
  })
}

export function saveFilter(data) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/load/criteria`,
    data: data,
    method: "POST",
    headers: {
      'portal-token': true,
      "system-source": systemInfo.isCommand ? "fleet" : "dispatcher",
    }});
}
export function saveFilterDSP(data) {
  return service({
    url: `/dispatcher/load/criteria`,
    data: data,
    method: "POST",
    headers: {
      'portal-token': true
    }
  });
}
export function getFilter() {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/load/criteria`,
    method: "get",
    headers: {
      'portal-token': true,
      "system-source": systemInfo.isCommand ? "fleet" : "dispatcher",
    }
  });
}
export function getFilterDSP() {
  return service({
    url: `/dispatcher/load/criteria`,
    method: "get",
    headers: {
      'portal-token': true
    }
  });
}
export function getLoadList (page,data) {
    return service({
      url: `/fleet/dispatch/v2/load/query?page=${page}&size=15`,
      method: 'post',
      data: data,
      headers: {
        'portal-token': true,
      },
    })
}

export function getLoadMapData (data) {
    return service({
      url: `/fleet/dispatch/v2/load/query?type=map`,
      method: 'post',
      data: data,
      headers: {
        'portal-token': true,
      },
    })
}

export function loadDetail (taskId) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/detail?loadId=${taskId}`,
    method: 'get',
    headers: {
      'portal-token': true,
    },
  })
}

export function loadAdd (data) {
  return service({
    url: `/fleet/dispatch/v2/load/add`,
    method: 'post',
    data: data,
    isNotPrompt: true,
    headers: {
      'portal-token': true,
    },
  })
}

export function loadDel (loadsId, type, notes) {
  let obj = notes ? {note: notes} : ''
  return service({
    url: `/fleet/dispatch/v2/load/delete`,
    method: 'POST',
    data: {
      loadsId: loadsId,
      type: type,
      ...obj,
    },
    headers: {
      'portal-token': true,
    },
  })
}

export function importLoad (type,list) {
  return axiosV2({
    url: `/fleet/dispatch/load/list/download?type=${type == 'all' ? 'selected' : type}&${list}`,
    method: 'POST',
    data: {},
    responseType: "blob",
    headers: {
      'portal-token': true,
    },
  })
}

export function getLoadFileList (id, data) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/get/document`,
    method: 'POST',
    data: {relatedId: id,...data},
    headers: {
      'portal-token': true,
    },
  })
}

export function addDocumentFile (params) {
  return service({
    url: `/fleet/dispatch/v2/web/load/document/add?documentType=${params.documentType}&name=${params.title}&taskId=${params.id}&url=${params.url}`,
    method: 'PUT',
    data: {},
    headers: {
      'portal-token': true,
    },
  })
}

export function editDocumentName (params) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/edit/document?fileId=${params.id}&fileName=${params.fileName}&fleetCompanyId=${params.fleetCompanyId}&isPrivate=${params.isPrivate}`,
    method: 'PUT',
    data: {},
    headers: {
      'portal-token': true,
    },
  })
}

export function delDocumentName(id) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/delete/document?fileId=${id}`,
    method: 'delete',
    data: {},
    headers: {
      'portal-token': true,
    },
  })
}


export function paymentReportdelDocumentName(data) {
  return service({
    url: `/fleet/payment_report/delete/false`,
    method: 'post',
    data: data,
    headers: {
      'portal-token': true,
    },
  })
}


export function re_assign(driverId,data,emptyMils) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/reassign?driverId=${driverId}`,
    data: {
      driverId: driverId,
      loadId: data,
      emptyMiles: emptyMils
    },
    isNotPrompt: true,
    method: 'POST',
    headers: {
      'portal-token': true
    }
  })
} 

// export function assign(driverId,loadsId,time) {
//   return service({
//     // &time=${time}
//     url: `/fleet/dispatch/v2/load/assign?driverId=${driverId}&loadsId=${loadsId}&time=${time}`,
//     method: 'get',
//     headers: {
//       'portal-token': true
//     }
//   })
// } 

export function assign(driverId,data,time,emptyMiles) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/assign?driverId=${driverId}&time=${time}`,
    method: 'post',
    data: {loadId: data, driverId: driverId, time: time, emptyMiles: emptyMiles},
    isNotPrompt: true,
    headers: {
      'portal-token': true
    }
  })
} 

export function getData() {
    return service({
      url: `/fleet/dispatch/enums/get`,
      method: 'get',
      headers: {
        'portal-token': true
      }
    })
}

export function editLoadStatus(id,status,data) {
  return service({
    url: `/fleet/dispatch/load_status/set?loadId=${id}&status=${status}`,
    method: 'post',
    data,
    headers: {
      'portal-token': true
    }
  })
} 

export function changeLoadStatus(loadId, status, stopid) {
  return service({
    url: `/fleet/dispatch/timeline/set/V2?loadId=${loadId}&status=${status}${stopid ? '&stopId='+stopid : '' }`,
    method: 'get',
    headers: {
      'portal-token': true
    }
  })
}

export function saveHistory(loadId, status, stopid, historyList) {
  // /dispatch/v2/timeline/history/save?history=1212121&loadId=11511&status=started"
  // console.log(historyList,'179');
  return service({
    url: `/fleet/dispatch/v2/timeline/history/save?loadId=${loadId}&status=${status}${stopid ? '&stopId='+stopid : '' }`,
    method: 'post',
    data: {
      history: historyList
    },
    headers: {
      'portal-token': true
    }
  })
}

// url: '/fleet/route/info/share',

export function loadAssignRoute(loadsId,data) {
  let city = [loadsId.loadInfo.deliveryAddress,loadsId.loadInfo.pickupAddress]
  return service({
    url: `/fleet/route/info/share?taskId=${loadsId.id}`,
    method: 'put',
    data: {
      truckModel: {},
      sendToUserId: 0,
      routingMode: 'truck',
      routingOption: {
        difficultTurns: true,
        dirtRoad: true,
        toll:false,
        tunnel:false
      },
      shape: data.shape,
      waypoint: data.waypoint.map((item,index) => {
        return {
          mappedPosition: item.mappedPosition,
          originalPosition: item.originalPosition,
          shapeIndex: item.shapeIndex,
          mappedRoadName: city[index],
          timezone: 'EST'
        }
      }),
      leg: data.sections.map(sections => {
        return {maneuver : sections.actions._json.map(x => {
            return {position: x.position}
          })}
      })
    },
    
    headers: {
      'portal-token': true
    }
  })
} 

export function editLoadTimeLine(id,status,data) {
  return service({
    url: `/fleet/dispatch/timeline/set?loadId=${id}&status=${status}`,
    method: 'POST',
    data: data,
    headers: {
      'portal-token': true
    }
  })
} 

export function editLoad(loadsId,data) {
  return service({
    url: `/fleet/dispatch/v2/load/edit?edit=true&loadsId=${loadsId}`,
    method: 'POST',
    data: data,
    headers: {
      'portal-token': true
    }
  })
}

export function getVehicleList(type) {
  // type
  return service({
    url: `/fleet/truck/eld/assign/vehicle/list?type=${type}`,
    method: 'GET',
    headers: {
      'portal-token': true
    }
  })
} 

export function getEldList(id) {
  // type
  return service({
    url: `/fleet/truck/eld/vehicle/location?eldTruckId=${id}`,
    method: 'GET',
    headers: {
      'portal-token': true
    }
  })
}

export function assignVehicle(truckId,loadid,type) {
  // type
  return service({
    url: `/fleet/truck/eld/assign/vehicle?truckId=${truckId}&loadId=${loadid}&type=${type}`,
    method: 'GET',
    headers: {
      'portal-token': true
    }
  })
}


export function getBrokerList() {
  return service({
    url: `/fleet/broker_info/pdf_config`,
    method: 'GET',
    headers: {
      'portal-token': true
    }
  })
} 

export function uploadRpcFile(data) {
  return service({
    url: `/fleet/dispatch/analyze/pdfV2`,
    data: data,
    method: 'post',
    headers: {
      'portal-token': true,
    }
  })
}

export function loadAddDistance(distance,loadid) {
  // type
  return service({
    url: `/fleet/dispatch/v2/load/distance/add?distance=${distance}&load_id=${loadid}`,
    method: 'POST',
    headers: {
      'portal-token': true
    }
  })
}

export function getShowLoadId( ) {
  return service({
    url: "/fleet/dispatch/v2/get/default/load_id",
    method: "GET",
    headers: {
      'portal-token': true
    }
  });
}

export function getDispatherList() {
  return service({
    url: `/fleet/dispatch/v2/company/member/get`,
    method: 'POST',
    headers: {
      'portal-token': true
    }
  })
}
export function calculateRoute(data) {
  return service({
    url: `/fleet/dispatch/v2/get/load/route`,
    data: data,
    method: "POST",
    headers: {
      'portal-token': true
    }
  });
}

export const getDriverList = (isCommand, id) => {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/user/latest/gps/info?page=1&size=10000${!isCommand && id ? `&loadId=${id}` : ''}`,
    headers: {
      "Content-Type": "application/json",
      "portal-token": true,
    },
  });
};

export function getOperator(data) {
  return service({
    url: `/fleet/owner/list`,
    data: {
      model: data
    },
    method: "POST",
    headers: {
      'portal-token': true
    }
  });
}

export function getTripIdInfo(id) {
  return service({
    url: `/fleet/load/trip/get/load/json?loadId=${id}`,
    method: 'GET',
    headers: {
      'portal-token': true
    }
  })
} 

export function calcLoadEmptyMiles(data) {
  return service({
    url: `/fleet/load/V4/get/driver/empty/miles`,
    method: 'POST',
    data: data,
    headers: {
      'portal-token': true
    }
  })
}

const services = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 30000,
})
export function uploadImage(fileJson) {
  const form = new FormData();
  const headers = {
    'Content-Typ': 'multipart/form-data'
  }
  form.append('image'||'pdf', fileJson.origin, fileJson.name)
  return services.post(process.env.VUE_APP_UPLOAD_IMAGE, form, {headers: headers})
}
